require("./mainFrameController");
require("./topFrame/topFrameController");
require("./sidebar/sidebarContentController");
require("./sidebar/sidebarFooterController");
require("./collapsableMenu/collapsableMenu");

require("../login/login");
require("../mobileLogin/mobileLogin");
require("../locked/locked");
require("../home/home");
require("../coverage/coverage");
require("../schedule/schedule");
require("../pricing/pricing");
require("../information/information");
require("../registration/registration");
require("../purchase/purchase");
require("../myProfile/myProfile");
require("../myHockeyTv/myHockeyTv");
require("../player/player");
require("../userProfile/userProfile");
require("../favorites/favorites");
require("../gamesOfTheWeek/gamesOfTheWeek");
require("../passwordReset/passwordReset");
require('../purchase/billingInfo/billingInfo');
require('../accountSettings/accountSettings');
require('../accessDenied/accessDenied');
require('../admin/admin');
require('../rokuConnect/rokuConnect');
require('../brand/brand');
require('../changeEmail/changeEmail');
require('../sessionTimeout/sessionTimeout');
require('../broadcastStatus/broadcastStatus');
require("../howToWatch/howToWatch");
require("../promo/promo");
require("../promo/redeemPromo");

"use strict";

angular.module('app.mainFrame', [
  'app.mainFrame.mainFrameController',
  'app.mainFrame.topFrameController',
  'app.mainFrame.sidebarContentController',
  'app.mainFrame.sidebarFooterController',
  'app.mainFrame.collapsableMenu',

  'app.login',
  'app.mobileLogin',
  'app.locked',
  'app.home',
  'app.coverage',
  'app.schedule',
  'app.pricing',
  'app.information',
  'app.registration',
  'app.purchase',
  'app.myProfile',
  'app.myHockeyTv',
  'app.player',
  'app.userProfile',
  'app.favorites',
  'app.gamesOfTheWeek',
  'app.passwordReset',
  'app.purchase.billingInfo',
  'app.accountSettings',
  'app.accessDenied',
  'app.admin',
  'app.rokuConnect',
  'app.brand',
  'app.changeEmail',
  'app.sessionTimeout',
  'app.broadcastStatus',
  'app.howToWatch',
  'app.promo',
  'app.redeemPromo'
])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {

      let sidebarFooterTemplate = 'components/mainFrame/sidebar/sidebarFooterView.html';
      if (product.Code != 'htv') {
        sidebarFooterTemplate = 'assets/templates/' + product.Code + '/mainFrame/sidebar/sidebarFooterView.html';
      }

      $stateProvider.state('app', {
        abstract: true,
        views: {
          '': {
            templateUrl: 'components/mainFrame/mainFrameView.html',
            controller: 'app.mainFrame.mainFrameController'
          },
          'topFrame@app': {
            templateUrl: 'components/mainFrame/topFrame/topFrameView.html',
            controller: 'app.mainFrame.topFrameController'
          },
          'sidebarContent@app': {
            templateUrl: 'components/mainFrame/sidebar/sidebarContentView.html',
            controller: 'app.mainFrame.sidebarContentController'
          },
          'sidebarFooter@app': {
            templateUrl: sidebarFooterTemplate,
            controller: 'app.mainFrame.sidebarFooterController'
          }
        }
      });
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/mainFrame.js